export function getSafeRedirectPath(path: string | null | undefined): string {
  if (
    typeof path !== 'string' ||
    !path.startsWith('/') ||
    path.startsWith('//') ||
    path.includes('://')
  ) {
    return '/';
  }
  return path;
}
